import styled from 'styled-components';

const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #e5e5e5;
`;

export default Divider;
